import { render, staticRenderFns } from "./ComponentTelephone.vue?vue&type=template&id=4c84e11e&scoped=true&"
import script from "./ComponentTelephone.vue?vue&type=script&lang=js&"
export * from "./ComponentTelephone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c84e11e",
  null
  
)

export default component.exports